import { render } from "./EnvelopeCreate.vue?vue&type=template&id=5161d1ca"
import script from "./EnvelopeCreate.vue?vue&type=script&lang=js"
export * from "./EnvelopeCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__